import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchNewEcrf = async ({ listAll } = {}) => {
  const token = localStorage.getItem("token");

  const url = listAll
    ? `${__API_URL__}/api/ecrf/get_new_ecrf/?listAll=true`
    : `${__API_URL__}/api/ecrf/get_new_ecrf/`;

  const response = await axios.get(url, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response?.data?.data;
};

const useGetNewEcrfs = ({ listAll, enabled = true } = {}) => {
  return useQuery({
    queryKey: ["ecrfs_list", listAll],
    queryFn: () => fetchNewEcrf({ listAll }),
    enabled,
    refetchOnWindowFocus: false,
  });
};

export default useGetNewEcrfs;
